import { JSON_CONTENT_TYPE } from '../../constant/constants';
import { TelegramMessageDto } from '../../dto/TelegramMessageDto';
import { IApiParams } from '../../interface/IApiParams';
import { secureToken } from '../../utils/utils';
import { getApiTelegramBot } from '../getApiTelegramBot';

export const apiSendTelegramMessage = async (dto: TelegramMessageDto) => {
  const params: IApiParams = {
    url: `/sendMessage.php?${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': 'telega',
    },
  };
  return getApiTelegramBot(params, 'POST', dto);
};
